module.exports = __webpack_public_path__ + "static/media/DSC01101.e7887d33.jpg";